/* Pilates Society — tote monogram customizer.
   Builds the font / colour / placement pickers, drives the live on-tote canvas
   preview, enforces the 10-char + script rules, and on add-to-cart (when a
   monogram is set) AJAX-adds the tote + the hidden +5 KWD add-on, then sends
   the customer to the cart. Plain orders fall through to the theme's form post. */
(function () {
  "use strict";

  var root = document.querySelector("[data-ps-mono]");
  if (!root) return;

  var MAX = 10;
  var ADDON_VARIANT = root.dataset.addonVariant || "";
  var CART_URL = root.dataset.cartUrl || "/cart";

  var FONTS = {
    en: [
      { key: "Great Vibes", css: "PSMonoGreatVibes" },
      { key: "Cormorant",   css: "PSMonoCormorant" }
    ],
    ar: [
      { key: "Amiri",      css: "PSMonoAmiri" },
      { key: "El Messiri", css: "PSMonoElMessiri" }
    ]
  };
  var COLOURS = [
    { name: "Dusty Rose", hex: "#D8A7A7" },
    { name: "Soft Blush", hex: "#EAD1CF" },
    { name: "Taupe",      hex: "#C5B7AE" },
    { name: "Deep Cocoa", hex: "#3A2E2B" },
    { name: "Muted Red",  hex: "#A94442" }
  ];
  // Placement coords are normalised (fraction of the tote image). Best estimate
  // from Sara's marked photos — refine to exact cm once Sara confirms.
  var PLACEMENTS = [
    { key: "A", name: "back", base: "a", cx: 0.50, cy: 0.50, maxW: 0.26 },
    { key: "B", name: "inside", base: "b", cx: 0.50, cy: 0.40, maxW: 0.18 }
  ];
  // EN: latin letters/digits/space. AR: Arabic blocks + digits + space.
  var RE = {
    en: /[^A-Za-z0-9 ]/g,
    ar: /[^؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿0-9 ]/g
  };

  var state = { lang: "en", text: "", font: null, colour: null, place: PLACEMENTS[0] };

  var el = {
    entryToggle: document.querySelector("[data-ps-mono-on]"), // lives in the product column
    panel:      root.querySelector("[data-ps-mono-panel]"),
    canvas:     root.querySelector("[data-ps-mono-canvas]"),
    preview:    root.querySelector("[data-ps-mono-preview]"),
    skeleton:   root.querySelector("[data-ps-mono-skeleton]"),
    langs:      root.querySelectorAll("[data-ps-mono-lang]"),
    input:      root.querySelector("[data-ps-mono-text]"),
    count:      root.querySelector("[data-ps-mono-count]"),
    countWrap:  root.querySelector(".ps-mono-count"),
    fonts:      root.querySelector("[data-ps-mono-fonts]"),
    colours:    root.querySelector("[data-ps-mono-colours]"),
    colourName: root.querySelector("[data-ps-mono-colour-name]"),
    places:     root.querySelector("[data-ps-mono-places]"),
    confirm:    root.querySelector("[data-ps-mono-confirm]"),
    error:      root.querySelector("[data-ps-mono-error]"),
    addBtn:     root.querySelector("[data-ps-mono-add]")
  };

  /* ---- base tote images -------------------------------------------------- */
  var bases = {};
  ["a", "b"].forEach(function (k) {
    var img = new Image();
    img.src = root.dataset["base" + k.toUpperCase()];
    bases[k] = img;
  });

  function fontCss(key) {
    var all = FONTS.en.concat(FONTS.ar);
    for (var i = 0; i < all.length; i++) if (all[i].key === key) return all[i].css;
    return "serif";
  }
  function isLight(hex) {
    var r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16), b = parseInt(hex.substr(5, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 165;
  }

  /* ---- canvas draw — reused by the live preview and the placement thumbs -- */
  function draw(canvas, opts) {
    var ctx = canvas.getContext("2d");
    var W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    var img = bases[opts.place.base] || bases.a;
    if (img && img.complete && img.naturalWidth) {
      // cover-fit
      var s = Math.max(W / img.naturalWidth, H / img.naturalHeight);
      var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
    } else {
      ctx.fillStyle = "#EFE7E2"; ctx.fillRect(0, 0, W, H);
    }
    var cx = opts.place.cx * W, cy = opts.place.cy * H, maxW = opts.place.maxW * W;
    if (opts.text) {
      var size = Math.round(H * 0.075);
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.direction = opts.lang === "ar" ? "rtl" : "ltr";
      ctx.fillStyle = opts.colour ? opts.colour.hex : "#3A2E2B";
      for (var i = 0; i < 12; i++) {
        ctx.font = size + "px '" + fontCss(opts.font) + "', serif";
        if (ctx.measureText(opts.text).width <= maxW || size <= 12) break;
        size -= 4;
      }
      ctx.fillText(opts.text, cx, cy);
    } else if (opts.zone) {
      ctx.save();
      ctx.strokeStyle = "rgba(58,46,43,.45)";
      ctx.setLineDash([7, 6]); ctx.lineWidth = 2;
      var zw = maxW, zh = H * 0.085;
      ctx.strokeRect(cx - zw / 2, cy - zh / 2, zw, zh);
      ctx.restore();
    }
  }

  function renderPreview() {
    var t = state.text.trim();
    var hasText = !!t;
    el.preview.classList.toggle("has-text", hasText);
    draw(el.canvas, {
      place: state.place, text: hasText ? t : "",
      font: state.font, colour: state.colour, lang: state.lang,
      zone: !hasText
    });
  }

  /* ---- font chips (rebuilt per language; sample = the customer's text) ---- */
  function buildFonts() {
    el.fonts.innerHTML = "";
    state.font = null;
    FONTS[state.lang].forEach(function (f) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "ps-mono-font";
      b.setAttribute("role", "radio"); b.setAttribute("aria-checked", "false");
      var sample = state.text.trim() || (state.lang === "ar" ? "سلمى" : "Aa");
      b.innerHTML =
        '<span class="ps-mono-font-name">' + f.key + "</span>" +
        '<span class="ps-mono-font-sample" dir="' + (state.lang === "ar" ? "rtl" : "ltr") +
        '" style="font-family:\'' + f.css + "',serif\">" + escapeHtml(sample) + "</span>";
      b.addEventListener("click", function () {
        state.font = f.key;
        el.fonts.querySelectorAll(".ps-mono-font").forEach(function (x) {
          var on = x === b; x.classList.toggle("on", on); x.setAttribute("aria-checked", on ? "true" : "false");
        });
        renderPreview();
      });
      el.fonts.appendChild(b);
    });
    // default-select the first font so the preview shows as soon as text is typed
    var firstFont = el.fonts.querySelector(".ps-mono-font");
    if (firstFont) firstFont.click();
  }
  function refreshFontSamples() {
    var sample = state.text.trim() || (state.lang === "ar" ? "سلمى" : "Aa");
    el.fonts.querySelectorAll(".ps-mono-font-sample").forEach(function (s) { s.textContent = sample; });
  }

  /* ---- colour swatches -------------------------------------------------- */
  function buildColours() {
    COLOURS.forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "ps-mono-colour" + (isLight(c.hex) ? " is-light" : "");
      b.style.background = c.hex;
      b.setAttribute("role", "radio"); b.setAttribute("aria-checked", "false");
      b.setAttribute("aria-label", c.name);
      b.innerHTML = '<span class="ps-mono-colour-tick" aria-hidden="true">✓</span>';
      b.addEventListener("click", function () {
        state.colour = c;
        el.colours.querySelectorAll(".ps-mono-colour").forEach(function (x) {
          var on = x === b; x.classList.toggle("on", on); x.setAttribute("aria-checked", on ? "true" : "false");
        });
        if (el.colourName) el.colourName.textContent = c.name;
        renderPreview();
      });
      el.colours.appendChild(b);
    });
    // default-select a high-contrast thread colour so the preview reads immediately
    var defColour = el.colours.querySelectorAll(".ps-mono-colour")[3];
    if (defColour) defColour.click();
  }

  /* ---- placement cards -------------------------------------------------- */
  function buildPlaces() {
    PLACEMENTS.forEach(function (p, idx) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "ps-mono-place" + (idx === 0 ? " on" : "");
      b.setAttribute("role", "radio"); b.setAttribute("aria-checked", idx === 0 ? "true" : "false");
      var thumb = document.createElement("canvas");
      thumb.className = "ps-mono-place-img"; thumb.width = 240; thumb.height = 240;
      var label = document.createElement("span");
      label.className = "ps-mono-place-name"; label.textContent = p.name;
      b.appendChild(thumb); b.appendChild(label);
      b.addEventListener("click", function () {
        state.place = p;
        el.places.querySelectorAll(".ps-mono-place").forEach(function (x) {
          var on = x === b; x.classList.toggle("on", on); x.setAttribute("aria-checked", on ? "true" : "false");
        });
        renderPreview();
      });
      el.places.appendChild(b);
      b._thumb = thumb; b._place = p;
    });
  }
  function renderPlaceThumbs() {
    el.places.querySelectorAll(".ps-mono-place").forEach(function (b) {
      draw(b._thumb, { place: b._place, text: "", zone: true });
    });
  }

  /* ---- validation ------------------------------------------------------- */
  function isValid() {
    return el.entryToggle.checked &&
      state.text.trim().length >= 1 && !!state.font && !!state.colour && !!state.place &&
      el.confirm.checked;
  }
  function escapeHtml(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

  /* ---- events ----------------------------------------------------------- */
  el.entryToggle.addEventListener("change", function () {
    var on = el.entryToggle.checked;
    root.hidden = !on;                       // the panel section lives below the product block
    clearError();
    if (on) {
      renderPreview();
      requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  });

  el.langs.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var lang = btn.getAttribute("data-ps-mono-lang");
      if (lang === state.lang) return;
      state.lang = lang;
      el.langs.forEach(function (b) {
        var on = b === btn; b.classList.toggle("on", on); b.setAttribute("aria-checked", on ? "true" : "false");
      });
      state.text = "";                       // script changed — clear
      el.input.value = "";
      el.input.classList.toggle("is-ar", lang === "ar");
      el.input.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
      el.count.textContent = "0"; el.countWrap.classList.remove("near");
      buildFonts();
      renderPreview();
    });
  });

  el.input.addEventListener("input", function () {
    var cleaned = el.input.value.replace(RE[state.lang], "").slice(0, MAX);
    if (cleaned !== el.input.value) el.input.value = cleaned;
    state.text = cleaned;
    el.count.textContent = String(cleaned.length);
    el.countWrap.classList.toggle("near", cleaned.length >= 9);
    refreshFontSamples();
    renderPreview();
    clearError();
  });

  el.confirm.addEventListener("change", clearError);

  function clearError() { el.error.hidden = true; el.error.textContent = ""; }
  function showError(msg) {
    el.error.textContent = msg; el.error.hidden = false;
    el.panel.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /* ---- add to cart ------------------------------------------------------ */
  function addToCart() {
    var toteId = root.dataset.toteVariant;
    var items = [{
      id: Number(toteId), quantity: 1,
      properties: {
        "Monogram": state.text.trim(),
        "Font": state.font,
        "Language": state.lang === "ar" ? "Arabic" : "English",
        "Thread colour": state.colour.name,
        "Placement": state.place.name
      }
    }];
    if (ADDON_VARIANT) {
      items.push({ id: Number(ADDON_VARIANT), quantity: 1, properties: { "_for": "monogram on the everyday tote" } });
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart add failed");
      window.location.href = CART_URL;
    });
  }

  /* ---- the customizer's own add-to-bag button --------------------------- */
  if (el.addBtn) {
    el.addBtn.addEventListener("click", function () {
      if (!isValid()) {
        if (state.text.trim().length < 1) return showError("Add your monogram text to continue.");
        if (!state.font)                  return showError("Pick a font for your monogram.");
        if (!state.colour)                return showError("Pick a thread colour.");
        if (!state.place)                 return showError("Pick where the monogram goes.");
        if (!el.confirm.checked)          return showError("Please tick the confirmation box.");
        return;
      }
      clearError();
      el.addBtn.classList.add("loading");
      el.addBtn.setAttribute("aria-disabled", "true");
      addToCart().catch(function () {
        el.addBtn.classList.remove("loading");
        el.addBtn.removeAttribute("aria-disabled");
        showError("Something went wrong adding to cart. Please try again.");
      });
    });
  }

  /* ---- init ------------------------------------------------------------- */
  buildFonts();
  buildColours();
  buildPlaces();
  el.input.setAttribute("dir", "ltr");

  // wait for the embroidery fonts before the first paint, so samples are true
  el.skeleton.hidden = false;
  var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  ready.then(function () {
    el.skeleton.hidden = true;
    renderPlaceThumbs();
    renderPreview();
  });
  // also draw once images load (in case fonts resolve first)
  ["a", "b"].forEach(function (k) {
    bases[k].addEventListener("load", function () { renderPlaceThumbs(); renderPreview(); });
  });
})();
